import React, { useState } from 'react';
import NavBar from '../components/navbar';
import AuthModal from '../components/AuthModal';

export default function Privacy({ onProfileClick, onBillingClick, onSeatsUpdate }) {
  const [showAuthModal, setShowAuthModal] = useState(false);

  return (
    <div className="App">
  <NavBar onSignInClick={() => setShowAuthModal(true)} onProfileClick={onProfileClick} onBillingClick={onBillingClick} onSeatsUpdate={onSeatsUpdate} />
        <AuthModal showAuthModal={showAuthModal} setShowAuthModal={setShowAuthModal} />
        <header className="App-header" style={{
          background: 'linear-gradient(180deg, #eef2f0 0%, #e4ece8 100%)',
          borderBottom: '1px solid #c8d8d2',
          boxShadow: '0 1px 3px rgba(15, 23, 42, 0.07)',
          borderRadius: 0,
          margin: 0,
          padding: '0 20px',
          minHeight: 42,
          flexShrink: 0,
        }}>
          <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%', height: '100%' }}>
            <h2 style={{
              margin: 0, color: '#1e3a2f',
              fontSize: 18, fontWeight: 700,
              letterSpacing: '-0.01em',
            }}>Privacy Policy</h2>
          </div>
        </header>
        <p style={{ fontSize: '25px', color: '#333333' }}>
            <br/>
            Your privacy is important to us. SmartClose does not collect or store personal data unless explicitly provided by the user for specific services.<br/>
            We may use Google APIs (such as Google Task and Calendar) solely to authenticate users. We do not share or sell any user data. <br/>
            If you have questions, contact us at: agent@smartclose.app <br/>
        </p>
    </div>
  );
}
